const appstleSubscriptionTweaks = () => {
  
  if (document.querySelector('[data-product-form]')) {
    function updateProductPrice() {
      //appstle-active-option
      const price = document.querySelector('.appstle-active-option .appstle_subscription_amount').textContent,
        compareAtPrice = document.querySelector('.price__compare-at--single')?.textContent,
        currentPriceEl = document.querySelector('.product__price .price__current [data-price]'),
        oneTimePurchaseCompareEl = document.querySelector('.appstle_one_time_price_wrapper .appstle_subscription_amount_compare_at_price');

      currentPriceEl.textContent = price;
      if (oneTimePurchaseCompareEl) {
        oneTimePurchaseCompareEl.textContent = (compareAtPrice ? compareAtPrice : '');
      }
    }
    // Fires when user selects 'Subscribe'
    document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', function(event) {
      updateProductPrice();
    });

    // Fires when user selects 'One-Time Purchase'
    document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected', function(event) {
      updateProductPrice();
    });

    // Fires when delivery frequency changes
    document.addEventListener('AppstleSubscription:SubscriptionWidget:sellingPlanChanged', function(event) {
      updateProductPrice();
    });
  }

}

addEventListener('DOMContentLoaded', appstleSubscriptionTweaks);